import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../Translations/LenguageContext";
import FormatDateTime from "../Functions/FormatDate";
import ErrorMessage from "../Components/ErrorMessage";
import { TbReload } from "react-icons/tb";
import Spinner from "../Components/Spinner";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenContextLogsModal = ({
    account_id,
    show,
    handleClose,
    selectedSource,
    openContextModal
}) => {
    const { t } = useLanguage()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const fetchData = async () => {
        if (!show) return;
        setLoading(true);
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_context_source_logs`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    source_id: selectedSource
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setData(result.data || []);
        } catch (err) {
            console.error("Error fetching models:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    useEffect(() => {
        fetchData();
    }, [show]);

    const closeModal = () => {
        handleClose();
        setLoading(false)
        setErrorMessage({ message: "", display: false });
        setData([])
        openContextModal()
    };

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.context.context_logs_title}
                </p>
                <button className="context_window_footer_btn" onClick={fetchData}>
                    {loading ? (
                        <Spinner loading={loading}/>
                    ):(
                        <TbReload/>
                    )}
                </button>
            </div>
            <div className="modal_main_cont">
                {loading ? (
                    <div className="loading_logs_cont fade-in">
                        <p>{t.context.loading_logs}</p>
                    </div>
                ) : data.length == 0 ? (
                    <div className="organizations_cont_no_items_mex fade-in">
                        <p>{t.no_data_found}</p>
                    </div>
                ) : (
                    <div className="logs_cont_wrapper">
                        <div className="logs_cont_header">
                            <p className="logs_cont_item_time fade-in">{t.context.logs_timestamp}</p>
                            <p className="logs_cont_item_message fade-in">{t.context.logs_message}</p>
                        </div>
                        <div className="logs_cont_body">
                            {data.map((log) => (
                                <div className={`logs_cont_item ${log.severity == 2 && "logs_cont_item_error"} ${log.severity == 1 && "logs_cont_item_warning"}`}>
                                    <p className="logs_cont_item_time fade-in">{FormatDateTime(log.created_at)}</p>
                                    <p className="logs_cont_item_message fade-in">{log.message}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        <i className="fa-solid fa-chevron-left"></i> {t.back}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OpenContextLogsModal;